// extracted by mini-css-extract-plugin
module.exports = {"text_icon":"TextIcon_text_icon__IoE_n","back_icon":"TextIcon_back_icon__CWi6f","icon":"TextIcon_icon__q4kAS"};